module.exports = __webpack_public_path__ + "img/out-0001-b--auto--50pct.cbdeb98f.jpg";